import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewerDataService } from '../../viewer-data.service';
import { ActorActionsApiClient } from 'src/app/services/api-clients/actor-actions.api-client';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    templateUrl: './perform-action-approve.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PerformActionApproveModal implements OnInit {

  @Output('approve') approve = new EventEmitter();
  @Output('close') close = new EventEmitter();

  requestName = this.viewerDataService.get_RequestName;
  public buttonEnabled: boolean = true;

  /**
   * Number of the current actor action
   */
  expectedActionNumber: number = 1;
  currentActorInviteId!: string;

  constructor(public activeModal: NgbActiveModal,
    private viewerDataService: ViewerDataService,
    private actorActionsApiClient: ActorActionsApiClient,
    private toastService: ToastService) {
    // Must not be empty. It's approved by a comment.
    this.viewerDataService.getCurrentActor$().subscribe(currentActor => {
      this.currentActorInviteId = currentActor.id;
      this.expectedActionNumber = currentActor.badgeNumber;
    });
  }

  ngOnInit(): void {
    this.buttonEnabled = true;
  }

  back() {
    this.activeModal.close();
    this.close.emit();
  }
  clickApprove() {
    this.buttonEnabled = false;
    this.actorActionsApiClient.approve(this.viewerDataService.get_RequestGuid, this.currentActorInviteId)
      .subscribe({
        next: () => {
          this.viewerDataService.actorCompletedAction(this.currentActorInviteId);
          this.activeModal.close();
        },
        error: (err) => {
          if (err.status === 400 && err.error) {
            const backendMessage = err.error?.toLowerCase();
            if (backendMessage?.includes('credits')) {
              this.toastService.showErrorByKey('Toasts.InsufficientCreditError');
            } else {
              this.toastService.showErrorByKey("Toasts.ActionNotPossible");
            }
          }
        }
      });



    // .subscribe(() => {
    //   this.viewerDataService.actorCompletedAction(this.currentActorInviteId);
    //   this.activeModal.close();
    // });
  }

}
